import type { Events } from '~/plugins/emitter'

export default function loanDetail(value: Events['loan-open-user']['isAuth']) {
  return {
    event: 'web_bnpl_open',
    bnpl_auth: value,
  }
}
